/** The task-bank and generation problem codes an API error's body carries in `code` (QZ-D42). */
export const PROBLEM_CODES = {
  TaskNotFound: 'TaskNotFound',
  InvalidTask: 'InvalidTask',
  UnknownTag: 'UnknownTag',
  TaskNotDraft: 'TaskNotDraft',
  TransitionNotAllowed: 'TransitionNotAllowed',
  TaskChanged: 'TaskChanged',
  InvalidTagName: 'InvalidTagName',
  TagExists: 'TagExists',
  JobNotFound: 'JobNotFound',
  JobEnded: 'JobEnded',
  NoSources: 'NoSources',
  UnknownSource: 'UnknownSource',
  InvalidDomain: 'InvalidDomain',
  SourceExists: 'SourceExists',
  SourceNotFound: 'SourceNotFound',
  LastSource: 'LastSource',
  TooManySources: 'TooManySources',
  InvalidMaterial: 'InvalidMaterial',
  MaterialExpired: 'MaterialExpired',
  ExtractionNotFound: 'ExtractionNotFound',
  MaterialTooLarge: 'MaterialTooLarge',
  InvalidPageRange: 'InvalidPageRange',
  JobNotEnded: 'JobNotEnded',
  SourceReferenceLocked: 'SourceReferenceLocked',
  /** A consumer job request names a job configuration that does not exist (EXJ-D5). */
  JobConfigNotFound: 'JobConfigNotFound',
  /** An admin tries to create a job configuration whose id is already taken (EXJ-D5). */
  JobConfigExists: 'JobConfigExists',
  /** A user tries to start a second job while one of theirs is unfinished (QZ-D200, EXJ-D5). */
  JobInProgress: 'JobInProgress',
} as const;
export type ProblemCode = keyof typeof PROBLEM_CODES;
